import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ISubjectInput } from "@/interfaces/subject.interface";
import subjectService from "@/services/subject.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateSubjectProps = UpdateByIdProps<ISubjectInput>;

export type UseUpdateSubjectReturn = {
  update: (props: UpdateSubjectProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateSubject = (): UseUpdateSubjectReturn => {
  const response = useUpdate<ISubjectInput>({
    operation: (formData, subjectId) => subjectService.update(formData, subjectId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, update } = response;

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateSubject;
